export default __webpack_public_path__ + "static/media/12b.d6733796.png";